import {CustomColumnDataType} from 'notebook/structured-tables/custom-columns/CustomColumnConstants';
import {
  BaseTypedValueType,
  Cell,
  ColumnConstraint,
  TableColumnType,
  TypedValue,
} from 'notebook/tables/TableConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import {Optional} from 'util/Types';

export function isRawTextColumn(columnConstraint: Optional<ColumnConstraint>): boolean {
  return (
    columnConstraint?.columnDefinition != null &&
    ([
      TableColumnType.STRING,
      TableColumnType.CONTAINERS,
      TableColumnType.BOX,
      TableColumnType.BIOENTITY_NAME,
      TableColumnType.PLATE,
      TableColumnType.MEASUREMENT_AMOUNT,
      TableColumnType.INGREDIENT_COMPONENT_LOT_TEXT,
      TableColumnType.INGREDIENT_CATALOG_ID,
      TableColumnType.INGREDIENT_NOTES,
    ].includes(columnConstraint.columnDefinition.type) ||
      (columnConstraint.columnDefinition.type === TableColumnType.CUSTOM &&
        columnConstraint.columnDefinition.customColumnConfig.dataType === CustomColumnDataType.TEXT) ||
      (columnConstraint.columnDefinition.type === TableColumnType.TAG_VALUE &&
        [FieldType.TEXT, FieldType.LONG_TEXT].includes(columnConstraint.columnDefinition.tagSchemaFieldType)))
  );
}

/**
 * Parse cell contents into a typedValue.
 */
export default function parseTypedValue(
  cell: Cell,
  columnConstraint: Optional<ColumnConstraint>
): TypedValue | null {
  const {typedValue, text} = cell;
  if (typedValue != null) {
    return typedValue;
  }
  if (text && isRawTextColumn(columnConstraint)) {
    return {
      type: BaseTypedValueType.STRING,
      rawValue: text,
    };
  }
  return null;
}
